module.exports = __webpack_public_path__ + "static/media/Ph.d94873bd.png";